<template>
    <div class="pageContent orders">
      <LoadingModal />
      <!-- <Header :show="true" :isShadow="false" title="我的订单" /> -->
      <div class="headerNav">
        <van-nav-bar
          title="提现记录"
          left-arrow
          :fixed="true"
          :zIndex="1001"
          style="background: var(--depRechargeColor)"
          @click-left="onClickLeft"
        >
          <template #left>
            <i class="iconfont iconjiantou1" style="font-size: 26px"> </i>
          </template>
        </van-nav-bar>
      </div>
      <van-tabs
        color="var(--depRechargeColor)"
        title-inactive-color="#333333"
        title-active-color="var(--depRechargeColor)"
        line-height="3px"
        @click="getList"
        v-model="acticeName"
      >
        <van-tab
          v-for="arry in vanList"
          :title="arry.title"
          :key="arry.name"
          :name="arry.name"
        >
          <div class="couponList">
            <div class="orderList">
              <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    @load="onLoad"
                    :immediate-check="false"
                    :offset="1"
                    ref="vanList"
                >
                    <ListItem
                    v-for="(item, index) in list"
                    :key="index"
                    :itemData="item"
                    class="isModal"
                    />
                </van-list>
                </van-pull-refresh>
              <van-overlay
                z-index="1002"
                :show="showDetail"
                @click="showDetail = false"
              >
                <div class="pageFlexColumn itemModal" v-if="showDetail">
                  <ListItem :itemData="orderInfo" class="isModal" :show="false" />
                  <div
                    class="pageBgBlock pageBannarShadow radios"
                    @click="showDetail = !showDetail"
                  >
                    关闭
                  </div>
                </div>
              </van-overlay>
            </div>
            <van-empty image="search" :description="finishText" v-if="tips" />
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </template>
  
  <script>
  import { getWithdraw } from "api/user";
  
  import ListItem from "./WithdrawItem";
  // /*global $ */
  export default {
    components: {
      ListItem,
    },
    data() {
      return {
        vanList: [
          { title: "处理中", name: "0" },
          { title: "失败", name: "1" },
          { title: "已完成", name: "2" },
          { title: "全部记录", name: "-1" },
        ],
        list: [],
        loading: true,
        isLoading: false,
        finished: false,
        currentPages: 1,
        type: -1,
        acticeName: -1,
        len: 0,
        finishText: "",
        className: "",
        result: true,
        tips: false,
        isShow: false,
        bgImg: require("assets/code.png"),
        // 详情
        selItem: { name: 2 },
        showDetail: false,
        orderInfo: {},
        selectStatus: -1,
      };
    },
    created() {},
    mounted() {
      var acticeName = this.$route.query.type;
      if (acticeName == undefined) {
        this.acticeName = -1;
      } else {
        this.acticeName = acticeName;
      }
      this.list = [];
      this.onLoad();
    },
    methods: {
      onClickLeft() {
        this.$push({
          path: "/coupons",
        });
      },
      onRefresh(){
        setTimeout(() => {
            this.currentPages = 1;
            this.len = 0;
            this.tips = false;
            this.finished = true;
            this.loading = true;
        }, 500);
      },
      
      getList(type) {
        if (this.type != type) {
          this.$replace({
            query: {
              type,
            },
          });
          this.finishText = "";
          this.type = type;
          this.list = [];
          this.currentPages = 1;
          this.len = 0;
          this.finished = false;
          this.loading = true;
          this.tips = false;
          this.selectStatus = type;
          this.onLoad();
        }
      },
      onLoad() {
        if (this.result) {
          this.result = false;
          setTimeout(async () => {
            if (this.selectStatus == this.type) {
              if (this.currentPages == 1) {
                this.list = [];
              }
              if (this.type == -1) {
                this.type = this.acticeName;
                this.selectStatus = this.acticeName;
              }
              if (-1 <= this.type && this.type < 4) {
                // 异步更新数据
                getWithdraw(this.currentPages, this.type).then((res) => {
                  this.isLoading = false;
                  this.finished = false;
                  this.loading = false;
                  if (res.status === 200) {
                    this.result = true;
                    this.len += res.data.records.length;
                    for (let i = 0; i < res.data.records.length; i++) {
                      switch (res.data.records[i].withdrawStatus) {
                        case 0:
                          res.data.records[i].orderStatusText = "处理中";
                          break;
                        case 1:
                          res.data.records[i].orderStatusText = "已失败";
                          break;
                        case 2:
                          res.data.records[i].orderStatusText = "已完成";
                          break;
                      }
                      this.list.push(res.data.records[i]);
                    }
                    if (this.len >= res.data.total || res.data.records == []) {
                      this.finished = true;
                      this.tips = false;
                    }
                    this.loading = false;
                    this.currentPages++;
                  } else {
                    this.result = true;
                    this.finished = true;
                  }
                  if (this.list.length <= 0) {
                    this.className = "";
                    this.finishText = "暂无相关订单";
                    this.tips = true;
                  }
                  this.$nextTick(function () {
                    this.isShow = true;
                    this.$store.commit("setPageLoading", false);
                  });
                });
              }
            }
          }, 500);
        }
      },
    },
  };
  </script>
  
  <style scoped lang="less">
  .orders {
    // background: linear-gradient(
    //   180deg,
    //   var(--depRechargeColor) 70px,
    //   var(--bgColor) 0
    // );
    background: #e3c414;
    .pageFlexBetween {
      color: #fff;
      .title {
        margin-top: 20px;
        margin-bottom: 16px;
        font-size: 24px;
      }
      .iconsearch {
        font-size: 36px;
        margin-top: 5px;
      }
    }
    /deep/ .van-tabs__wrap {
      height: 50px;
      border-radius: 5px;
      box-shadow: 0px 0px 10px rgba(170, 170, 170, 0.349);
      .van-tab {
        font-size: 14px;
        color: #666;
        // border-right: 1px solid var(--lineColor);
        box-shadow: 0px 0px 3px 0.1px var(--lineColor);
        .van-info {
          right: -10px;
          background-color: var(--depRechargeColor);
        }
        /deep/.van-tabs__line {
          border-radius: 0;
        }
        // box-shadow: 0px 0px 3px 0.1px #999;
      }
    }
  }
  .headerNav {
    height: 46px;
    /deep/.van-nav-bar {
      color: #fff;
      .van-icon,
      .van-nav-bar__text,
      .van-nav-bar__title,
      a {
        color: inherit;
        vertical-align: middle;
      }
      .van-nav-bar__title {
        font-size: 18px;
      }
      .van-icon,
      .iconfont {
        font-size: 24px;
        vertical-align: middle;
      }
      .iconjiantou1 {
        font-size: 26px;
      }
    }
    .van-nav-bar::after {
      content: "";
      border: none;
    }
  }
  .orderList {
    // position: relative;
    .itemModal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 0 20px;
      z-index: 1003;
      .isModal {
        margin-top: -100px;
      }
    }
    .radios {
      background: #fff;
      color: var(--redColor);
      font-size: 14px;
      width: 42px;
      height: 42px;
      margin-top: 5px;
      text-align: center;
    }
    @themeColor: #fff;
    .listItem {
      padding: 0;
      margin-top: 15px;
      min-height: 90px;
      font-size: var(--pFont);
      .title {
        height: 40px;
        font-size: var(--titleFont);
        color: var(--titleColor);
        p {
          margin-left: 24%;
        }
        span {
          color: var(--redColor);
          margin-right: 13px;
        }
      }
      .line {
        height: 5px;
        margin: 0 2px;
        margin-top: -5px;
        box-shadow: 0px 4px 4px 2px #f4f4f4;
      }
      .icons {
        width: 19%;
        float: left;
        color: #666;
        margin: -25px 0 0 10px;
        .pageBgBlock {
          color: #fff;
          width: 50px;
          height: 50px;
          background: var(--redColor);
          .iconfont {
            font-size: 28px;
            margin: 4px 10px;
          }
        }
        p {
          margin-top: 15px;
          padding: 5px 8px;
          font-size: var(--spanFont);
          color: var(--depBlueColor);
          background: #e0f4fd;
        }
      }
      .unPay {
        p {
          color: var(--greenColor);
          background: #eef6e0;
        }
      }
      .processing {
        p {
          background: #fdecd5;
          color: var(--depYelColor);
        }
      }
      .detail {
        padding: 12px 0;
        margin-left: 24%;
        span {
          font-size: var(--smallFont);
          color: var(--hidColor);
          display: inline-block;
          line-height: 1.5;
        }
        .remark {
          margin-top: 4px;
          padding-top: 3px;
          font-size: var(--pFont);
          border-top: 1px solid var(--lineColor);
          color: var(--hidColor);
        }
        h5 {
          margin-top: 6px;
          color: var(--depBlueColor);
        }
      }
      .btnGroud {
        .pageSmallBtns {
          width: 50%;
          height: 35px;
          border-radius: 0px;
        }
        .cancel {
          color: var(--depHidColor) !important;
        }
      }
      .footer {
        color: #fff;
        background: var(--depBlueColor);
        height: 35px;
        padding: 0 15px;
        box-sizing: border-box;
        p {
          flex: 1;
        }
        .pageSmallBtns {
          color: var(--depBlueColor) !important;
          border-radius: 5px;
          font-size: var(--spanFont);
          height: 24px;
        }
      }
    }
    .isUsed {
      background: var(--bgColor);
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(249, 249, 249, 0.5);
      }
    }
    
    .van-list{
      min-height: 500px;
    }
  }
  </style>
  